import React from "react";
import ReactPaginate from "react-paginate";
import "common/common.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";

const Paginate = ({ totalPages, handleNextPage, currentPage }) => {
  return (
    <ReactPaginate
      previousLabel={<FontAwesomeIcon icon={faChevronLeft} />}
      nextLabel={<FontAwesomeIcon icon={faChevronRight} />}
      breakLabel={"..."}
      pageCount={totalPages}
      marginPagesDisplayed={2}
      pageRangeDisplayed={2}
      onPageChange={(data) => handleNextPage(data)}
      containerClassName={`vds-pagination`}
      pageClassName={"vds-page-item"}
      pageLinkClassName={"vds-page-link"}
      previousClassName={"vds-page-item"}
      previousLinkClassName={"vds-page-link"}
      breakClassName={"vds-page-item"}
      breakLinkClassName={"vds-page-link"}
      nextClassName={"vds-page-item"}
      nextLinkClassName={"vds-page-link"}
      activeClassName={"vds-active"}
      activeLinkClassName={"vds-active-link"}
      disabledClassName={"vds-page-disabled-item"}
      forcePage={currentPage - 1}
    />
  );
};

export default Paginate;
